<!--下拉选择器公共弹出页面-->
<template>
  <div class="select-chart-c" :style="{height: `100vh`}">
    <div
      class="select-box"
    >
      <div class="select-title">选择{{ selectData.config.defaultText }}</div>
      <!--如果是日期选择器-->
      <div class="year" v-if="selectData.config.isDate">
        <h3 class="y">{{ year }}年</h3>
        <ul class="month" v-if="selectMonth" @onkeydown="Dosomething($event)">
          <li
            v-for="num in 12"
            :id="'m_' + num"
            :key="'m_' + num"
            :class="{
              coocaa_btn1: num <= month,
              btnFocus: num === parseInt(selectMonth),
              selectItem: num === parseInt(selectMonth)
            }"
            rel="select"
            :lival="num < 10 ? `0${num}` : num"
            @click="haldleSelectMonth(num)"
          >
            {{ num }}月
          </li>
        </ul>
      </div>
      <!--其它选择器-->
      <div v-else class="year">
        <ul class="month" @onkeydown="Dosomething($event)">
          <li
            v-for="(item, index) of allData"
            :ref="`select_${index + 1}`"
            :key="index"
            :id="`select_${index}`"
            class="coocaa_btn1"
            v-focusable
            :class="index === parseInt(selectMonth) ? 'selectItem' : ''"
            @up="contentUp(index + 1)"
            @down="contentDown(index + 1)"
            @left="contentLeft(index + 1)"
            @right="contentRight(index + 1)"
            @click="handleSelectItem(index)"
          >
            {{ item[selectData.config.label] || item.label }}
          </li>
        </ul>
      </div>
      <div class="select-btn">
        <div class="select-btn__container">
          <div
            class="coocaa_btn1 sbtn"
            ref="ok"
            @click="handleOk"
            v-focusable
          >
            确定
          </div>
          <div
            class="coocaa_btn1 sbtn"
            ref="back"
            @click="handleBack"
            v-focusable
          >
            返回
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import ccMapMixin from '@/mixins/ccmap'
import common from '@/mixins/common'
import scalseNum from '@/mixins/scalseNum'
export default {
  mixins: [common, scalseNum],
  props: {
    selectData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      selectMonth: ''
    }
  },
  computed: {
    isAndroid () {
      return this.$store.state.app.isAndroid
    },
    month () {
      const date = new Date()
      return date.getMonth() + 1
    },
    year () {
      const date = new Date()
      return date.getFullYear()
    },
    allData () {
      const config = this.selectData.config
      let data = this.$lodash.cloneDeep(this.selectData.data)
      // .map(item => {
      //   return {
      //     label: item[config.label],
      //     value: item[config.value]
      //   }
      // })
      if (this.selectData.config.isShowAll) {
        data.unshift(this.evil(`{'${config.label || 'label'}': '全部${this.selectData.config.defaultText}','${config.value || 'value'}': ''}`))
      }
      return data
    }
  },
  methods: {
    contentUp (i) { // 上
      const after = i % 6
      this.$tv.requestFocus(this.$refs[`select_${after === 0 ? i : after}`])
    },
    contentDown (i) { // 下
      const downI = i + 6
      const size = this.allData.length
      this.$tv.requestFocus(this.$refs[size === 6 ? 'ok' : i === size ? 'ok' : `select_${downI <= size ? downI : size}`])
    },
    contentLeft (i) { // 右
      const after = i - 1
      this.$tv.requestFocus(this.$refs[`select_${after > 0 ? after : 1}`])
    },
    contentRight (i) { // 左
      const after = i + 1
      const size = this.allData.length
      if (after <= size) {
        this.$tv.requestFocus(this.$refs[`select_${after}`])
      } else {
        this.$tv.requestFocus(this.$refs.ok)
      }
    },

    evil (fn) {
      if (this.isJSON(fn)) {
        return JSON.parse(fn)
      } else {
        const Fn = Function
        return new Fn('return ' + fn)()
      }
    },
    isJSON (str) {
      if (typeof str === 'string') {
        try {
          const obj = JSON.parse(str)
          if (typeof obj === 'object' && obj) {
            return true
          } else {
            return false
          }
        } catch (e) {
          return false
        }
      } else if (typeof str === 'object' && str) {
        return true
      }
    },
    bindKey (target) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.$tv.limitingEl = document.querySelector('.select-box')
        }, 1000)
      })

      // this.$tv.requestFocus(this.$refs.select_0)
    },
    haldleSelectMonth (num) {
      if (this.keyCode) {
        this.keyCode = 0
      } else {
        if (num <= this.month) {
          num < 10 ? this.selectMonth = '0' + num : this.selectMonth = num
        }
      }
    },
    handleBack () {
      this.$emit('closeSelect', false)
      this.$tv.limitingEl = null
    },
    // 确定查询
    handleOk () {
      const { DBAKey } = this.selectData.config
      const mapLabel = this.selectData.config.mapCol[0].value
      const mapValue = this.selectData.config.mapCol[1].value
      let tempObj
      if (this.selectData.config.isDate) {
        const date = {
          time: `2021-${this.selectMonth}`,
          isCurMonth: parseInt(this.selectMonth) === this.month
        }
        this.$store.dispatch('toggleDate', date)
        tempObj = {
          ...date,
          isDate: true
        }
      } else {
        tempObj = this.allData[this.selectMonth]
      }
      let chooseItem = Object.assign({}, tempObj, {
        key: DBAKey,
        mapValue,
        mapLabel
      })
      this.$store.dispatch('searchKanBanData', chooseItem).then(() => {
        if (this.$route.query.id === '65' && this.$route.query.from) {
          this.$router.push({
            path: '/kanban-config-view',
            query: {
              id: this.$route.query.id
            }
          })
        }
        this.$emit('closeSelect', true)
      })
      this.$tv.limitingEl = null
    },
    handleSelectItem (idx) {
      this.selectMonth = idx
      this.$nextTick(() => {
        this.$tv.requestFocus(this.$refs[`select_${idx + 1}`])
      })
    }
  },
  mounted () {
    // 将子组件挂在到body上
    this.$nextTick(() => {
      this.$tv.requestFocus(this.$refs.select_1)
    //   const body = document.getElementById('app')
    //   if (body.append) {
    //     body.append(this.$el)
    //   } else {
    //     body.appendChild(this.$el)
    //   }
    //   this.bindKey()
    })
    // 将选择的值赋值上去
    const { DBAKey, isShowAll, isDate } = this.selectData.config
    if (isDate) {
      this.selectMonth = this.$store.state.app.date.time.substr(5)
    } else {
      const tempData = this.$store.state.app.selectVal
      const chooseItem = tempData.filter(item => {
        return DBAKey === item.type
      })
      // 如果有选择显示全部
      if (!chooseItem.length) {
        this.selectMonth = isShowAll ? 0 : null
      } else {
        this.selectMonth = this.allData.findIndex(item => {
          const mapVal = this.selectData.config.mapCol[1].value
          return item[mapVal] === chooseItem[0]['values']
        })
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.select-chart-c
  position fixed
  top 0
  left 0
  display flex
  align-items center
  justify-content center
  /*width 1920px*/
  /*height 100vh*/
  width 100%
  height 100%
  color #fff
  // background rgba(0, 0, 0, .8)//url('~@/assets/images/select-month-bg.jpg')
  overflow hidden
  .select-title
    font-size 2.2rem
    text-align center
  .select-box
    width 43.8rem
    background #34373E
    padding 2.5rem
    box-sizing border-box
    border-radius .8rem
  .year
    width 100%
    h3.y
      font-size 1.6rem
      font-weight normal
      margin 2rem 0 1rem -0.1rem
  ul.month
    padding 1rem 0
    display flex
    margin 0 -0.2rem
    flex-wrap wrap
    li
      width 6rem
      height 2.5rem
      line-height 2.5rem !important
      font-size 1.4rem
      text-align center
      margin 0 .2rem .4rem
      background rgba(255,255,255,.1)
      border-radius .3rem
      border 1px solid rgba(255,255,255,.0)
      box-sizing border-box
      background-repeat no-repeat !important
      background-position right top
      cursor pointer
      overflow hidden
    .selectItem
      border 1px solid #007EFF
      background-image url('~@/assets/images/blue-corner.png')
    .selectItem.btnFocus
      border 1px solid #007EFF
      background-image url('~@/assets/images/white-corner.png') !important
      background-repeat no-repeat !important
      background-position right top !important
    .coocaa_btn1
      cursor pointer
  ul.month li:not(.coocaa_btn1)
    color rgba(255,255,255,.3)
  .select-btn
    margin-top 4.2rem
    .select-btn__container
      display flex
      .sbtn
        flex 1
        text-align center
        height 4.5rem
        line-height 4.5rem !important
        background rgba(255,255,255,.1)
        border-radius .8rem
        cursor pointer
        &:first-child
          margin-right .75rem
        &:last-child
          margin 0 .2rem 0 .75rem
  .coocaa_btn1.btnFocus
    background #007eff !important
</style>
